import { render, staticRenderFns } from "./formulario-alumni.vue?vue&type=template&id=2a2b7f6b&scoped=true"
import script from "./formulario-alumni.vue?vue&type=script&lang=js"
export * from "./formulario-alumni.vue?vue&type=script&lang=js"
import style0 from "./formulario-alumni.vue?vue&type=style&index=0&id=2a2b7f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b7f6b",
  null
  
)

export default component.exports